import "./main.scss";
import VendorGrid from './VendorGrid';

const FashionBazaar = () => {
	return (
		<div>
			<VendorGrid />
		</div>
	);
};

export default FashionBazaar;